import '../../assets/Css/hero.css'
// import arctLogo from '../../assets/Images/Arct-logo.png'
import arctLogo from '../../assets/Images/arctLogo-removebg-preview.png'
import careerArc from '../../assets/Images/Carrer-arc.png'
// import careerArc2 from '../../assets/Images/Career_Arc-web.png'
import careerArc2 from '../../assets/Images/CareerArc LOGO.png'
import { useLocation, useNavigate } from 'react-router-dom'
import ShowTimeDate from '../TimeDate/TimeDate'
import { useEffect } from 'react'
import { useQr } from '../../Context/QrContext'


const HeroSection = () => {

  const { qrCodeId, setQrCodeId } = useQr();
  const location = useLocation();
  const navigate = useNavigate()
  // ✅ On mount: extract qr_code_id from URL and store it
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const qrScanId = params.get('qr_code_id');
    if (qrScanId) {
      setQrCodeId(qrScanId);
    }
  }, [location.search, setQrCodeId]);


  const handleRegisterClick = () => {
    // if (qrCodeId) {
    // navigate(`/arct/register?qr_code_id=${qrCodeId}`);/
    navigate(`/arct/register`);
    // } else {
    // alert("Invalid scan. Please scan the QR code again.");
    // }
  };


  return (
    <div className="herosections" style={{
      background: "#F9F9F9",
      position: 'relative',
      paddingTop: '50px',
      marginLeft: '-18px',
      marginRight: '-12px',
      width: 'calc(100% + 30px)'
    }}>
      <div className='row d-flex justify-content-center herocontainers' style={{ margin: 'auto' }}>
        {/* Left Section */}
        <div className='col-sm-12 col-md-10 col-xl-6'>
          <div className='row align-items-center navbar'>
            {/* ARC-T Logo */}
            <div className='col-8 col-sm-10 col-md-8 arcLogoContainer'>
              <img src={arctLogo} style={{ width: "100%", maxWidth: "250px", height: "auto" }} alt="ARC-T Logo" />
            </div>

            {/* Career Arc & Trust Info */}
            {/* <div className='col-4 col-sm-2 col-md-4 carrerImgContainerLogo'> */}
              {/* <div className='img-container me-2' style={{ width: '50%' }}> */}
              {/* <img
                src={careerArc2}
                style={{ width: "100%", height: "auto", maxWidth: "250px", backgroundColor: 'transparent' }}
                alt="Career Arc"
              /> */}
              {/* </div> */}

              {/* <div className='d-flex flex-column'>
                <div className='organised'>
                  <p>Organized By</p>
                  <p>A Unit Of </p>
                </div>
                <div className='trustname'>
                  <p>Purvanchal</p>
                  <p>Educational</p>
                  <p>Trust</p>
                </div>
              </div> */}
            {/* </div> */}
          </div>




          <div className='row mainheadinContainer'>
            {/* Headings */}
            <div className='col-xl-12 col-md-12 col-sm-12 headings mt-2'>
              <h1 className='justPassed'>Just Passed 12th </h1>
              <h1 className='wondering'>and Wondering? </h1>
              <p className='before'>Before choosing a course, a college take a pause.... <br />and take the test</p>
            </div>
          </div>

          {/* Register Button */}
          <div className='register-btn'>
            <button className='d-flex align-items-center' onClick={handleRegisterClick}>
              REGISTER NOW !
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none" style={{ marginLeft: "10px" }} xmlns="http://www.w3.org/2000/svg">
                <rect width="30" height="30" rx="6" fill="white" />
                <path d="M11.5 8L18.5 15L11.5 22" stroke="#F3A012" strokeWidth="2.5" strokeLinecap="round" />
              </svg>
            </button>
          </div>
        </div>

        {/* Right Section with background image */}
        <div className='col-sm-12 col-md-12 col-xl-6 imagecontainers'>
          <div className='rightPart'>
            {/* Background image of student is applied via CSS */}
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center ">
        <ShowTimeDate />
      </div>

    </div>
  )
}

export default HeroSection
